import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useToast } from "@kanda-libs/ks-design-library";
import { actions, type Company } from "@kanda-libs/ks-frontend-services";
import companySelectors from "store/selectors/company";
import useReloadInitialData from "hooks/useReloadInitialData";
import { useAppDispatch } from "components/shared/App";

export type ChangeDepositStateHook = [() => void, boolean];

export default function useChangeDepositState(): ChangeDepositStateHook {
  const dispatch = useAppDispatch();
  const company = useSelector(companySelectors.getEntity);
  const isSubmitting = useSelector(companySelectors.getIsSubmitting);
  const refreshAll = useReloadInitialData();
  const { showSuccess, showError } = useToast();

  const changeDepositState = useCallback(() => {
    const body = {
      ...company,
      skip_deposit: company?.skip_deposit === "Yes" ? "No" : "Yes",
    } as Company;
    const id = company?.id || "";

    dispatch(actions.putCompany({ body, params: { id } }));
  }, [
    company,
    showError,
    dispatch,
    actions.putCompany,
    refreshAll,
    showSuccess,
  ]);

  return [changeDepositState, isSubmitting];
}
